'use client'

import { authTokenAtom } from 'features/auth/atoms'
import { useEffect } from 'react'

import { isAuthenticatedAtom, userAtom } from '@/global-state'
import { getStore } from '@/store'

/**
 * Due to Jotai lazily initializing atoms when they are first read in a reactive context (with useAtom or useAtomValue), reading them imperatively with store.get() returns default value if the atom was not read with useAtom or useAtomValue first. This is an edge case since most atoms are read reactively in components but is needed for some atoms that aren't.
 * This component ensures those atoms are initialized when the app mounts.
 */
export const UseInitializeLazyAtoms = () => {
	useEffect(() => {
		const atomsToInitialize = [authTokenAtom, userAtom, isAuthenticatedAtom]

		atomsToInitialize.forEach((atom) => {
			const unsub = getStore().sub(atom, () => {})
			unsub()
		})
	}, [])

	return null
}
